import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import React from "react";
import {
  getCommission,
  getCommissionUploadDetail,
  getPayment,
  postCommissionInvoiceUpload,
} from "../../../data";

import {
  Link,
  useNavigate,
  useParams,
  useResolvedPath,
} from "react-router-dom";
import { useForm } from "react-hook-form";
import { AppLayout } from "../shared/layout";
import { Button } from "@/components/ui/button";

import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useRef, useState } from "react";
import { useToast } from "@/components/ui/use-toast";
import { PDFDownloadLink, PDFViewer, pdf } from "@react-pdf/renderer";
import { InvoicePdfEN } from "@/components";
export function CommissionInvoiceUploadManuelPdfENScreen() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  const [screenLoading, setScreenLoading] = useState(false);
  const [isReadyPdf, setIsReadyPdf] = useState(false);

  const pathname = useResolvedPath().pathname.split("/")[2];
  const navigate = useNavigate();

  const pdfDowloadLinkRef = useRef();

  const { data, isLoading, error } = useQuery({
    queryKey: ["commissionDetail", pathname],

    queryFn: async () => await getCommissionUploadDetail(pathname),
    retry: 1,
  });

  const mutation = useMutation({
    mutationKey: ["uploadPaymentInvoice"],

    mutationFn: (data) => {
      return postCommissionInvoiceUpload(data);
    },
    onSuccess: (response) => {
      setScreenLoading(false);
      //navigate("/payments");
      if (response.status === 200) {
        queryClient.invalidateQueries(["uploadPaymentInvoice", pathname]);
      }
    },
    onError: (error) => {
      setScreenLoading(false);
      const errorData = error?.response?.data;
      if (errorData?.alreadyUploaded) {
        toast({
          title: "Fatura Zaten Yüklendi",
          description: "Bu komisyon için zaten bir fatura yüklenmiş.",
          variant: "destructive",
        });
      } else {
        toast({
          title: "Hata",
          description: errorData?.error || "Bir şeyler ters gitti. Lütfen daha sonra tekrar deneyin.",
          variant: "destructive",
        });
      }
    },
  });

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    getValues,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const onSubmit = async (values) => {
    setScreenLoading(true);
    console.log(values);
    const { pdfFile } = values;

    var pdfData = {
      invoiceId: data.data.id,
      country:
        data?.data?.client == null
          ? data.data.country
          : data.data.client.country,

      email: data.data.email,
      lucaId: getLucaId(getValues("bankAccountHolder")),
      recipientName:
        getValues("recipientName") === undefined
          ? ""
          : getValues("recipientName"),
      finalAmount: data.data.finalAmount,
      bankAccountHolder:
        getValues("bankAccountHolder") === undefined
          ? ""
          : getValues("bankAccountHolder"),
      swift: getValues("swift") === undefined ? "" : getValues("swift"),
      iban: getValues("iban") === undefined ? "" : getValues("iban"),
      invoiceDate:
        getValues("invoiceDate") === undefined ? "" : getValues("invoiceDate"),
      phoneNumber:
        getValues("phoneNumber") === undefined ? "" : getValues("phoneNumber"),
    };

    if (
      pdfData.recipientName == undefined ||
      pdfData.bankAccountHolder == undefined ||
      pdfData.iban == undefined ||
      pdfData.phoneNumber == undefined ||
      pdfData.swift == undefined
    ) {
      setScreenLoading(false);
      toast({
        title: "Lütfen tüm zorunlu alanları doldurun",
        message: ``,
        type: "success",
      });
    } else {
      const formData = new FormData();
      formData.append("recipientName", pdfData.recipientName);
      formData.append("bankAccountHolder", pdfData.bankAccountHolder);
      formData.append("iban", pdfData.iban);
      formData.append("swift", pdfData.swift);
      formData.append("phoneNumber", pdfData.phoneNumber);
      formData.append("fileName", `${data.data.influencerName}-${data.data.id}`);
      formData.append("invoiceDate", pdfData.invoiceDate);
      formData.append("invoiceId", pdfData.invoiceId);

      console.log(pdfData);
      var blob = await pdf(InvoicePdfEN({ data: pdfData })).toBlob();
      formData.append("file", blob, "invoice.pdf");

      mutation.mutate({
        path: pathname,
        data: formData,
        invoiceId: data.data.payment.invoiceId,
      });
    }
  };

  const getLucaId = (bankAccountHolder) => {
    if (data.data.client) {
      if (data.data.client.lucaAccountName == bankAccountHolder) {
        return data.data.client.lucaId;
      }
    }
    return "";
  };

  const getCurrency = () => "₺"; // Sistem tek para birimi: TL

  if (isLoading || screenLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Card className="w-[350px] ">
          <CardHeader>
            <CardTitle>Fatura Yükle</CardTitle>
            <CardDescription>
              İsteğiniz işlenirken lütfen bekleyin
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="flex items-center justify-center">
              <div
                className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                role="status"
              >
                <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                  Yükleniyor...
                </span>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  const createPdf = (e) => {
    e.preventDefault();

    setValue(
      "invoiceDate",
      new Intl.DateTimeFormat("tr-TR", {
       day: "numeric",
       month: "numeric",
       year: "numeric",
      }).format(new Date())
    );
    var pdfData = {
      invoiceId: data.data.id,
      email: data.data.email,
      lucaId: getLucaId(getValues("bankAccountHolder")),
      country:
        data?.data?.client == null
          ? data.data.country
          : data.data.client.country,
      recipientName:
        getValues("recipientName") === undefined
          ? ""
          : getValues("recipientName"),
      finalAmount: data.data.finalAmount,
      bankAccountHolder:
        getValues("bankAccountHolder") === undefined
          ? ""
          : getValues("bankAccountHolder"),
      swift: getValues("swift") === undefined ? "" : getValues("swift"),
      iban: getValues("iban") === undefined ? "" : getValues("iban"),
      invoiceDate:
        getValues("invoiceDate") === undefined ? "" : getValues("invoiceDate"),
      phoneNumber:
        getValues("phoneNumber") === undefined ? "" : getValues("phoneNumber"),
    };

    if (
      pdfData.recipientName === "" ||
      pdfData.bankAccountHolder === "" ||
      pdfData.phoneNumber === "" ||
      pdfData.swift === ""
    ) {
      var message = "";
      if (pdfData.recipientName === "") {
        message += "Recipient Name, ";
      }
      if (pdfData.bankAccountHolder === "") {
        message += "Bank Account Holder, ";
      }
      if (pdfData.phoneNumber === "") {
        message += "Phone Number, ";
      }
      if (pdfData.swift === "") {
        message += "Swift, ";
      }
      toast({
        title: "Lütfen tüm zorunlu alanları doldurun:  " + message,

        type: "error",
      });
    } else {
      setIsReadyPdf(true);
    }
  };
  const handleRefresh = (e) => {
    e.preventDefault();
    window.location.reload();
  };

  if (error) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Card className="w-[350px] ">
          <CardHeader>
            <CardTitle>Hata</CardTitle>
            <CardDescription>
              Bir şeyler ters gitti. Lütfen daha sonra tekrar deneyin. Sorun devam ederse destek ekibimizle iletişime geçin.
            </CardDescription>
          </CardHeader>
        </Card>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center h-screen">
      {data.data.status == "Invoice Uploaded" ? (
        <div className="flex items-center justify-center h-screen">
          <Card className="w-[350px] ">
            <CardHeader>
              <CardTitle>Başarılı</CardTitle>
              <CardDescription>
                Faturanız başarıyla gönderildi. Bu sayfayı kapatabilirsiniz.
              </CardDescription>
            </CardHeader>
          </Card>
        </div>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)}>
          <Card className="w-[350px] ">
            <CardHeader>
              <CardTitle>Invoice İnformation</CardTitle>
              <CardDescription>
                Ödemeyi tamamlamak için zorunlu alanları doldurun
                process.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="grid w-full items-center gap-4">
                <div className="flex flex-col space-y-1.5">
                  <Label htmlFor="name">E-posta</Label>
                  <h1 id="name">{data.data.email}</h1>
                </div>

                <div className="flex flex-col space-y-1.5">
                  <Label htmlFor="framework">Ad Soyad</Label>

                  <Input
                    id="recipientName"
                    type="text"
                    onChange={(e) => {
                      setValue("recipientName", e.target.value);
                    }}
                  />
                </div>
                <div className="flex flex-col space-y-1.5">
                  <Label htmlFor="framework">Telefon Numarası</Label>

                  <Input
                    id="phoneNumber"
                    type="text"
                    onChange={(e) => {
                      setValue("phoneNumber", e.target.value);
                    }}
                    required
                  />
                </div>
                <div className="flex flex-col space-y-1.5">
                  <Label htmlFor="framework">Fatura Tarihi</Label>
                  <h1 id="name">
                    {new Intl.DateTimeFormat("tr-TR", {
                      day: "numeric",
                      month: "numeric",
                      year: "numeric",
                    }).format(new Date())}
                  </h1>
                </div>

                <div className="flex flex-col space-y-1.5">
                  <Label htmlFor="framework">
                    Hesap Sahibi Adı Soyadı
                  </Label>
                  <span className="text-red-500 text-sm">
                    Bu alana BANKA adınızı yazmayın
                  </span>

                  <Input
                    id="bankAccountHolder"
                    type="text"
                    onChange={(e) => {
                      setValue("bankAccountHolder", e.target.value);
                    }}
                  />
                </div>
                <div className="flex flex-col space-y-1.5">
                  <Label htmlFor="framework">IBAN</Label>

                  <Input
                    id="iban"
                    type="text"
                    onChange={(e) => {
                      setValue("iban", e.target.value);
                    }}
                  />
                </div>
                <div className="flex flex-col space-y-1.5">
                  <Label htmlFor="framework">SWIFT</Label>

                  <Input
                    id="swift"
                    type="text"
                    onChange={(e) => {
                      setValue("swift", e.target.value);
                    }}
                    required
                  />
                </div>
                <div className="flex flex-col space-y-1.5">
                  <Label htmlFor="name">Fatura Tutarı</Label>
                  <h1 id="name">
                    {data.data.finalAmount}{" "}
                    {getCurrency(
                      data.data.client == null
                        ? data.data.country
                        : data.data.client.country
                    )}
                  </h1>
                </div>
                {isReadyPdf && (
                  <div
                    style={{
                      flexDirection: "column",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <span>Fatura Oluşturuldu</span>
                    <div
                      style={{
                        justifyContent: "space-between",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        gap: "2px",
                      }}
                    >
                      <Button variant="destructive" asChild>
                        <PDFDownloadLink
                          ref={pdfDowloadLinkRef}
                          document={
                            <InvoicePdfEN
                              data={{
                                invoiceId: data.data.id,
                                email: data.data.email,
                                lucaId: getLucaId(
                                  getValues("bankAccountHolder")
                                ),
                                country:
                                  data?.data?.client == null
                                    ? data.data.country
                                    : data.data.client.country,
                                recipientName:
                                  getValues("recipientName") === undefined
                                    ? ""
                                    : getValues("recipientName"),
                                finalAmount: data.data.finalAmount,
                                bankAccountHolder:
                                  getValues("bankAccountHolder") === undefined
                                    ? ""
                                    : getValues("bankAccountHolder"),
                                swift:
                                  getValues("swift") === undefined
                                    ? ""
                                    : getValues("swift"),
                                iban:
                                  getValues("iban") === undefined
                                    ? ""
                                    : getValues("iban"),
                                invoiceDate:
                                  getValues("invoiceDate") === undefined
                                    ? ""
                                    : getValues("invoiceDate"),
                                phoneNumber:
                                  getValues("phoneNumber") === undefined
                                    ? ""
                                    : getValues("phoneNumber"),
                              }}
                            />
                          }
                          fileName={data.data.influencerName + ".pdf"}
                        >
                          {({ blob, url, loading, error }) =>
                            loading ? "Loading document..." : "Download Invoice"
                          }
                        </PDFDownloadLink>
                      </Button>
                      <Button onClick={(e) => handleRefresh(e)}>
                        Faturayı Yeniden Oluştur
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </CardContent>
            <CardFooter className="flex justify-end">
              {isReadyPdf && <Button>Onayla</Button>}
            </CardFooter>
          </Card>
        </form>
      )}
    </div>
  );
}
